import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./scss/style.scss";

import Loading from "./components/Loading";
import customHistory from "./utils/history";
import ErrorBoundary from "./components/ErrorBoundary";
import RegisterOperatorCompany from "./views/pages/register/RegisterOperatorCompany";
import RegisterCompany from "./views/pages/register/RegisterCompany";
import { ToastContainer } from "react-toastify";
import EmailValidate from "./views/EmailValidate";
import RegisterUser from "./views/RegisterUser";

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
const Receipt = React.lazy(() => import("./views/receipt/Receipt"));

class App extends Component {
  render() {
    return (
      <ErrorBoundary>
        <Router history={customHistory}>
          <React.Suspense fallback={<Loading />}>
            <Switch>
              <Route
                exact
                path="/login"
                name="Login Page"
                render={(props) => <Login {...props} />}
              />
              <Route
                exact
                path="/register/operator-company"
                name="Register Operator Company Page"
                render={(props) => <RegisterOperatorCompany {...props} />}
              />
              <Route
                exact
                path="/register/company"
                name="Register Company Page"
                render={(props) => <RegisterCompany {...props} />}
              />
              <Route
                exact
                path="/email/validate/:hash"
                name="Email Validate Page"
                render={(props) => <EmailValidate {...props} />}
              />
              <Route
                exact
                path="/register/user/:hash"
                name="Register User Page"
                render={(props) => <RegisterUser {...props} />}
              />
              <Route
                exact
                path="/404"
                name="Page 404"
                render={(props) => <Page404 {...props} />}
              />
              <Route
                exact
                path="/500"
                name="Page 500"
                render={(props) => <Page500 {...props} />}
              />
              <Route
                path="/receipt/:receiptId"
                exact
                render={(props) => <Receipt {...props} />}
              />
              <Route
                path="/"
                name="Home"
                render={(props) => <TheLayout {...props} />}
              />
            </Switch>

            <ToastContainer />
          </React.Suspense>
        </Router>
      </ErrorBoundary>
    );
  }
}

export default App;
